import React from 'react';
import { useDemo } from '../providers/DemoProvider';
import { PACKS } from '../../../data/packs';
import { Link } from 'react-router-dom';
import '../../muses/styles/MuseMarket.css';

const DEMO_PACKS_ALLOWED = ['Friendly Pack 1', 'Celestial Pack 1'];

const PremiumBadge = () => (
  <div style={{
    background: 'linear-gradient(135deg, #FFD700, #FFA000)',
    color: '#333',
    padding: '4px 10px',
    borderRadius: '12px',
    fontWeight: 900,
    fontSize: '0.8rem',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.25)',
    flexShrink: 0
  }}>
    🔒 Premium
  </div>
);


const DemoMuseMarket: React.FC = () => {
  const { wallet, buyPack, showLockedModal } = useDemo();

  const allPacks = Object.entries(PACKS);
  const buyablePacks = allPacks.filter(([id]) => DEMO_PACKS_ALLOWED.includes(id));
  const lockedPacks = allPacks.filter(([id]) => !DEMO_PACKS_ALLOWED.includes(id));

  return (
    <div className="market-container">
      <div className="market-header" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '2.5rem' }}>
        <h1 style={{ fontFamily: 'Fredoka One, Arial Rounded MT Bold, Arial, sans-serif', fontWeight: 900, fontSize: '3.5rem', color: '#111', margin: 0, letterSpacing: 2 }}>
          Muse Market
        </h1>
      </div>
      <div className="market-grid">
        {buyablePacks.map(([id, pack]) => {
          const packClass = `pack-${id.toLowerCase().replace(/\s+/g, '-').replace(/&/g, 'and')}`;
          return (
            <div key={id} className={`market-card ${packClass}`}>
              <div className="market-card-header">{pack.name}</div>
              <div className="market-card-body">
                <div>
                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '1rem 0 1.5rem 0', height: 60, position: 'relative', zIndex: 1 }}>
                    <div style={{ position: 'relative', width: 90, height: 60 }}>
                      <img src={pack.muses[0].img} alt={pack.muses[0].name} style={{ position: 'absolute', left: 0, top: 0, width: 48, height: 48, objectFit: 'cover', zIndex: 3, filter: 'drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3))', borderRadius: '6px' }} />
                      <img src={pack.muses[1].img} alt={pack.muses[1].name} style={{ position: 'absolute', left: 24, top: 8, width: 48, height: 48, objectFit: 'cover', zIndex: 2, filter: 'drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3))', borderRadius: '6px' }} />
                      <img src={pack.muses[2].img} alt={pack.muses[2].name} style={{ position: 'absolute', left: 48, top: 0, width: 48, height: 48, objectFit: 'cover', zIndex: 1, filter: 'drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3))', borderRadius: '6px' }} />
                    </div>
                  </div>
                  <p className="market-card-description">{pack.description}</p>
                </div>
                <button
                  onClick={() => buyPack(id, pack.price)}
                  className="market-button market-button-primary"
                  style={{ marginTop: 24, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 'var(--spacing-md)', position: 'relative' }}
                  disabled={wallet.balance < pack.price}
                >
                  <span style={{ fontWeight: 700, color: '#fff', background: 'rgba(255,255,255,0.2)', borderRadius: '0.5rem', padding: '0.2rem 0.5rem', fontSize: '0.9rem', display: 'flex', alignItems: 'center', gap: '0.3rem', position: 'absolute', left: '1rem' }}>
                    <span role="img" aria-label="token">💰</span> {pack.price}
                  </span>
                  <span>{wallet.balance < pack.price ? 'Not Enough 💰' : 'Buy Pack'}</span>
                </button>
              </div>
            </div>
          );
        })}
        {lockedPacks.map(([id, pack]) => {
          const packClass = `pack-${id.toLowerCase().replace(/\s+/g, '-').replace(/&/g, 'and')}`;
          return (
            <div 
              key={id} 
              className={`market-card ${packClass}`} 
              style={{ position: 'relative', overflow: 'hidden', cursor: 'pointer' }}
              onClick={showLockedModal}
            >
              <div className="market-card-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span>{pack.name}</span>
                <PremiumBadge />
              </div>
              <div className="market-card-body">
                <div>
                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '1rem 0 1.5rem 0', height: 60, position: 'relative', zIndex: 1 }}>
                    <div style={{ position: 'relative', width: 90, height: 60 }}>
                      <img src={pack.muses[0].img} alt={pack.muses[0].name} style={{ position: 'absolute', left: 0, top: 0, width: 48, height: 48, objectFit: 'cover', zIndex: 3, filter: 'drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3))', borderRadius: '6px' }} />
                      <img src={pack.muses[1].img} alt={pack.muses[1].name} style={{ position: 'absolute', left: 24, top: 8, width: 48, height: 48, objectFit: 'cover', zIndex: 2, filter: 'drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3))', borderRadius: '6px' }} />
                      <img src={pack.muses[2].img} alt={pack.muses[2].name} style={{ position: 'absolute', left: 48, top: 0, width: 48, height: 48, objectFit: 'cover', zIndex: 1, filter: 'drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3))', borderRadius: '6px' }} />
                    </div>
                  </div>
                  <p className="market-card-description">{pack.description}</p>
                </div>
                <div className="market-button market-button-secondary" style={{ 
                  marginTop: 24, 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center', 
                  gap: '1rem',
                  padding: 'var(--spacing-md)', 
                  position: 'relative', 
                  background: '#555', 
                  color: '#ccc', 
                  cursor: 'pointer',
                  textDecoration: 'none'
                }}>
                  <span style={{ 
                    fontWeight: 700, 
                    color: '#aaa', 
                    background: 'rgba(0,0,0,0.2)', 
                    borderRadius: '0.5rem', 
                    padding: '0.2rem 0.5rem', 
                    fontSize: '0.9rem', 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: '0.3rem',
                    lineHeight: 1
                  }}>
                    <span role="img" aria-label="token" style={{ marginRight: '4px' }}>💰</span> {pack.price}
                  </span>
                  <span>Unlock to Buy</span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DemoMuseMarket;
